import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { MpAdminService } from "../../../services/api/mp-admin.service";
import { MpAdminActions } from "../../actions/mp-admin.actions";
import { FailState } from "../../models/fail-state";

@Injectable()
export class AdminConsumerUserRemoveEffects {
	create = createEffect(() =>
		this.actions.pipe(
			ofType(MpAdminActions.consumerUsers.removeUser),
			switchMap((action) =>
				this.mpAdminService
					.removeConsumerUser(action.params.consumerId, action.params.userId)
					.pipe(
						map(() => MpAdminActions.consumerUsers.removeUserSuccess()),
						catchError((error) =>
							of(MpAdminActions.consumerUsers.removeUserFail(new FailState(error)))
						)
					)
			)
		)
	);

	constructor(
		private actions: Actions,
		private mpAdminService: MpAdminService
	) {}
}
